<template>
  <svg
    width="36"
    height="37"
    viewBox="0 0 36 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0)">
      <path
        d="M18.0417 36.6802C27.7067 36.6802 35.5417 28.6213 35.5417 18.6802C35.5417 8.73905 27.7067 0.680176 18.0417 0.680176C8.37676 0.680176 0.541748 8.73905 0.541748 18.6802C0.541748 28.6213 8.37676 36.6802 18.0417 36.6802Z"
        fill="#32BA7C"
      />
      <path
        d="M13.5701 26.8L22.5685 36.0555C30.0212 34.0113 35.5417 27.0271 35.5417 18.6801C35.5417 18.5098 35.5417 18.3394 35.5417 18.1691L28.4754 11.4688L13.5701 26.8Z"
        fill="#0AA06E"
      />
      <path
        d="M18.4834 22.7115C19.2563 23.5065 19.2563 24.8692 18.4834 25.6642L16.8825 27.3109C16.1096 28.1058 14.7847 28.1058 14.0118 27.3109L7.0008 20.0427C6.22792 19.2478 6.22792 17.885 7.0008 17.0901L8.60174 15.4434C9.37461 14.6484 10.6995 14.6484 11.4724 15.4434L18.4834 22.7115Z"
        fill="white"
      />
      <path
        d="M24.6112 10.1626C25.3841 9.36767 26.709 9.36767 27.4819 10.1626L29.0828 11.8093C29.8557 12.6043 29.8557 13.967 29.0828 14.762L16.9377 27.1973C16.1649 27.9923 14.8399 27.9923 14.0671 27.1973L12.4661 25.5506C11.6933 24.7557 11.6933 23.3929 12.4661 22.5979L24.6112 10.1626Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="35"
          height="36"
          fill="white"
          transform="translate(0.541748 0.680176)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "CheckSvg"
};
</script>

<style></style>
